import { ReportsModal } from '@/shared/components/reports-modal'
import { FiFile, FiUser } from 'react-icons/fi'
import { useLoaderData } from 'react-router-dom'

export const AssetReports = () => {
  const { data: assetReportColumns } = useLoaderData()

  const reportOptions = [
    {
      label: 'Tabla de activos 1.0',
      description:
        'Descarga la información de la tabla de activos 1.0. Puedes seleccionar las columnas',
      value: 'asset',
      icon: FiUser,
      columns: assetReportColumns
    },
    {
      label: 'Listado de documentos',
      description:
        'Descarga el listado de documentos asociados a los activos 1.0.',
      value: 'asset_attachments',
      icon: FiFile,
      columns: []
    }
  ]

  return <ReportsModal reportOptions={reportOptions} />
}
